import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.EXECUTIVE_SUMMARY}.${BUSINESS_TOOL_SUB_SECTIONS.EXECUTIVE_SUMMARY.MARKET_AND_CUSTOMERS}` as const;

export const EXECUTIVE_SUMMARY_MARKET_NAMES = {
  DYNAMICS: 'dynamics',
  COMPETITION_PLAN: 'competitionPlan',
} as const;

export interface IMarketAndCustomersExecutiveSummaryForm {
  [EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS]: string;
  [EXECUTIVE_SUMMARY_MARKET_NAMES.COMPETITION_PLAN]: string;
}

export const marketAndCustomersExecutiveSummaryInitialValues: IMarketAndCustomersExecutiveSummaryForm = {
  [EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS]: '',
  [EXECUTIVE_SUMMARY_MARKET_NAMES.COMPETITION_PLAN]: '',
};
